let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("amUuO")).then(() => parcelRequire('64R0b'));